import React, {useEffect, useState} from 'react';
import Prismic from '@prismicio/client'

import { RichText, Elements } from 'prismic-reactjs'
import './About.css';
import {orderBy} from 'lodash';
import NewsItem from './NewsItem.js';

const MODE = {ABOUT: 'about', ACADEMIC: 'academic_positions', HONORS : 'honors_awards_grants'};
const ORDERINGS = {'about': {}, 'academic_positions': {orderings: '[my.academic_positions.year_start desc, my.academic_positions.year_end desc]'}, 'honors_awards_grants': {pageSize: 100}}

const propsWithUniqueKey = function(props, key) {
    return Object.assign(props || {}, { key });
  };


const htmlSerializer = function(type, element, content, children, key) {

  var props = {};
  switch(type) {
    case Elements.image: 
      props = { src: element.url , alt: element.alt || '' };
      return React.createElement('img', propsWithUniqueKey(props, key));

    default: 
    if(content === "<space>"){
        return <span key={key} style={{display: "block", height: "100px"}}></span>;
    } else if (content === "<orcid>"){
        return <div><a id="cy-effective-orcid-url" class="underline" href="https://orcid.org/0000-0001-8808-0663" target="orcid.widget" rel="me noopener noreferrer" style={{"verticalAlign" : "top"}}> 
                    <img src="https://orcid.org/sites/default/files/images/orcid_16x16.png" style={{"width": "1em", "height": "1em"}} alt="ORCID iD icon"/>https://orcid.org/0000-0001-8808-0663</a></div>;
    }
      return null;
  }
};




const About = ({client}) => {
    
    const [mode, setMode] = useState(MODE.ABOUT);
    const [doc, setDoc] = useState(null);
    const [links, setLinks] = useState([]);

    useEffect(() => {
        if(mode){
            const fetchData = async () => {
                setDoc(null);
                const response = await client.query(
                  Prismic.Predicates.at('document.type', mode), ORDERINGS[mode]
                )
                if (response) {
                    setMode(response.results[0].type);
                    setDoc(response.results);
                }
              }
              fetchData()
        }
    }, [mode, client]);

    useEffect(() => {
        const fetchData = async () => {
            const response = await client.query(
                Prismic.Predicates.at('document.type', 'news_article'), {orderings : '[my.news_article.publication_date desc]', pageSize : 4}
            )
            if (response) {
                setLinks(response.results);
            }
            }
            fetchData()
    }, [client]);

    const render = () => {
        if(doc === null){
            return null;
        }
        if(mode === MODE.ABOUT && doc){
            return <RichText render={doc[0].data.content} htmlSerializer={htmlSerializer} />;
        }
        if(mode === MODE.ACADEMIC){
            const sorted = orderBy(doc, function(o){return [o.data.year_end ? o.data.year_end : 9999, o.data.year_start]}, ['desc', 'desc']);
            return(
                <div>
                    {sorted.map(d => <div className="academic-position" key={d.id}>
                        <div className="date">{d.data.year_start} / {d.data.year_end ? d.data.year_end : 'Present'}</div>
                        <div className="position">{d.data.position}</div>
                        <div className="university">{d.data.university}</div>
                        <div className="department">{d.data.department}</div>
                    </div>)}
                </div>
            )
        }
        if(mode === MODE.HONORS){
            const sorted = orderBy(doc, function(o){return [o.data.year, o.data.last_publication_date]}, ['desc', 'desc']);
            return(
                <div>
                    {sorted.map(d => <div className="honor" key={d.id}>
                        <div className="date">{d.data.year}{d.data.year_end ? ' - '+d.data.year_end : ''}</div>
                        <div className="title">{d.data.title}</div>
                        {d.data.details && <div className="details"><RichText render={d.data.details} /></div>}
                    </div>)}
                </div>
            )
        }
        return null;
    };

    return (
        <>
        <div className="Main">
            <div className="About">
                <h2>Summary of Accomplishments</h2>
                <div className="menu">
                    <ul>
                        <li className={mode === MODE.ABOUT ? 'selected' : ''} onClick={() => setMode(MODE.ABOUT)}>Bio</li>
                        <li className={mode === MODE.ACADEMIC ? 'selected' : ''} onClick={() => setMode(MODE.ACADEMIC)}>Academic Positions</li>
                        <li className="cv"><a download href="https://www.eng.auburn.edu/~aesmith/cv/cv.pdf">Download CV</a></li>
                    </ul>
                </div>
                <div className={"about-"+mode}>
                {render()}
                </div>
            </div>
        </div>
        <div className="Side">
            <div className="News">
            <h2>Links</h2>
            {links.map(n => (
                <NewsItem key={n.id} item={n} />
            ))}

            </div>
        </div>
        </>
    )

}

export default About;